import { forkJoin } from "rxjs";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Discover } from "src/models/discover";
import { Picture } from "src/models/picture";
import { DiscoverService } from "../../../services/discover.service";
import { PictureService } from "../../../services/picture.service";
import { ToastrService } from "ngx-toastr";
import { defaultIfEmpty } from "rxjs/operators";

@Component({
  selector: "app-edit-discover-modal",
  templateUrl: "./edit-discover-modal.component.html",
  styleUrls: ["./edit-discover-modal.component.scss"],
})
export class EditDiscoverModalComponent implements OnInit {
  discoverModel: Discover;
  discoverPictures: Picture[];
  picturesToRemove: Picture[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    private cd: ChangeDetectorRef,
    private discoverService: DiscoverService,
    protected pictureService: PictureService,
    private toast: ToastrService
  ) {
    if (bsModalRef.content?.discover) {
      this.discoverModel = bsModalRef.content.discover;
    } else {
      this.discoverModel = new Discover();
    }
  }

  ngOnInit(): void {
    if (this.discoverModel.id) {
      this.getDiscoverPictures();
    }
  }

  getDiscoverPictures(): void {
    this.pictureService._picturesCast.subscribe((pictures) => {
      this.discoverModel.pictures = pictures.sort((x) => x.order);
    });
    this.pictureService
      .getPicturesForDiscover(this.discoverModel.id)
      .subscribe();
  }

  getPictureName(path: string) {
    if (path) {
      const replaced = path
        .replace("/", "\\")
        .replace("Resources\\Pictures\\", "");
      const idx = replaced.indexOf("_");
      return replaced.slice(idx + 1);
    }
  }

  onFileChange(event) {
    if (event.target.files && event.target.files.length) {
      const files = event.target.files;
      if (!this.discoverModel.id) {
        this.discoverModel.pictures = [];
      }
      for (let file of files) {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => {
          const picture: Picture = new Picture();
          picture.order = 0;
          picture.displayName = "Discover";
          picture.file = <File>file;
          this.discoverModel.pictures.push(picture);

          // need to run CD since file load runs outside of zone
          this.cd.markForCheck();
        };
      }
    }
  }

  pictureChange(picture: Picture) {
    picture.changed = true;
  }

  removePictureFromDiscover(picture: Picture) {
    const nameOrId = picture.file ? picture.file.name : picture.id;
    if (this.discoverModel.id) {
      const p = this.discoverModel.pictures.find((x) => x.id === nameOrId);
      const idx = this.discoverModel.pictures.indexOf(p);
      this.discoverModel.pictures.splice(idx, 1);
      if (picture.id) {
        this.picturesToRemove.push(p);
      }
    } else {
      const p = this.discoverModel.pictures.find(
        (x) => x.file.name === nameOrId
      );
      const idx = this.discoverModel.pictures.indexOf(p);
      this.discoverModel.pictures.splice(idx, 1);
    }
  }

  saveDiscover() {
    if (this.discoverModel?.id) {
      const req = [];
      this.picturesToRemove.forEach((p) =>
        req.push(this.pictureService.removePicture(p))
      );
      console.log(this.discoverModel);
      forkJoin(req)
        .pipe(defaultIfEmpty(null))
        .subscribe(() => {
          this.discoverService.updateDiscover(this.discoverModel).subscribe(
            () => {
              if (
                this.discoverModel.pictures &&
                this.discoverModel.pictures.length > 0
              ) {
                this.discoverModel.pictures.forEach((picture) => {
                  if (picture.id && picture.changed) {
                    this.pictureService.updatePicture(picture, () => {});
                  } else if (!picture.id) {
                    picture.discoverId = this.discoverModel.id;
                    this.pictureService.addPicture(
                      picture,
                      (progress) => {},
                      () => {}
                    );
                  }
                });
              }
            },
            (err) => console.log(err),
            () => {
              this.bsModalRef.hide();
              this.toast.success("Place updated!");
            }
          );
        });
    } else {
      this.discoverService.addDiscover(this.discoverModel).subscribe(
        (newDiscover) => {
          this.discoverModel.pictures.forEach((picture) => {
            picture.discoverId = newDiscover.id;
            picture.order = -1;
            this.pictureService.addPicture(
              picture,
              (progress) => console.log(progress),
              () => {}
            );
          });
        },
        (err) => {
          this.toast.error("An error occured the place is deleted");
        },
        () => {
          this.bsModalRef.hide();
        }
      );
    }
  }

  close() {
    this.bsModalRef.hide();
  }
}
